module.exports = __webpack_public_path__ + "img/s2m-loader-small-greenBg.ab2c5a75.gif";